<a [href]="href()" [attr.target]="target() || null" [class]="linkClass()" [attr.rel]="target() === '_blank' ? 'noopener noreferrer' : null">
  @if (iconClass()) {
    <i [class]="iconClass()"></i>
  }
  @if (labelKey()) {
    <span>{{ labelKey() | translate }}</span>
  }
</a>
